<template>
  <div
    class="c-header -extended"
    :style="{
      'background-image': 'url(' + image + ')',
    }"
  >
    <ion-grid class="ion-no-padding">
      <ion-row class="c-header__content">
        <ion-col size="8" class="ion-align-self-end">
          <h1>{{ headline }}</h1>
          <ion-button
            v-if="!hideButton"
            mode="ios"
            class="c-dashboard-box__button ion-margin-top"
            expand="block"
            @click="
              openShowPaintype(() => {
                $emit('open-chat');
              })
            "
          >
            <ion-row class="ion-align-items-center" style="flex-grow: 1">
              <ion-col class="ion-text-left">
                <div class="c-typewriter">
                  <ion-note mode="ios" class="c-typewriter__text"
                    >Starten Sie den Roodie.Check …</ion-note
                  >
                </div>
              </ion-col>
              <ion-col size="auto">
                <ion-icon
                  :src="require('@lib/assets/icons/roodie.svg')"
                  style="font-size: 24px"
                />
              </ion-col>
            </ion-row>
          </ion-button>
        </ion-col>
        <ion-col size="4" class="c-header__image">
          <img :src="image" />
        </ion-col>
      </ion-row>
      <img v-if="logo" class="c-header__logo" :src="logo" :width="logoWidth" />
    </ion-grid>
  </div>
</template>

<script>
import {
  IonButton,
  IonGrid,
  IonRow,
  IonCol,
  IonNote,
  IonIcon,
} from "@ionic/vue";
import { chat } from "@/mixins/chat";

export default {
  mixins: [chat],
  emits: ["open-chat"],
  components: {
    IonButton,
    IonGrid,
    IonRow,
    IonCol,
    IonNote,
    IonIcon,
  },
  props: {
    headline: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    logo: {
      type: String,
      required: false,
      default: "",
    },
    logoWidth: {
      type: String,
      required: false,
      default: "",
    },
    hideButton: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style></style>
